/**
 * WorldAttribution - the credit that has to travel with World Bank data.
 *
 * CC BY 4.0 obliges us to credit the source and say if we changed anything,
 * wherever the data appears. The side-by-side panel on the local commodity
 * pages carried this from the start; the global pages did not, because they
 * only started showing Pink Sheet figures when the expired exchange feed was
 * replaced, and the credit did not follow the data across. A "Source: World
 * Bank Pink Sheet" byline names the source but not the licence, which is not
 * the same obligation.
 *
 * So it lives in one component, and every surface that shows the data renders
 * it. The text comes from the API rather than being written here, so the
 * wording cannot drift between the backend's idea of the credit and ours.
 */

import React from 'react';
import { Typography } from '@mui/material';
import { useThemeMode } from '../../context/ThemeContext';

function WorldAttribution({ text, sx }) {
  const { palette } = useThemeMode();
  if (!text) return null;
  return (
    <Typography
      sx={{
        fontSize: '0.68rem',
        color: palette.textMuted,
        fontStyle: 'italic',
        lineHeight: 1.5,
        ...sx,
      }}
    >
      {text}
    </Typography>
  );
}

export default WorldAttribution;
